import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import TitleComponent from "./components/TitleComponent";
import MapComponent from "./components/MapComponent";
import ComponentB from "./components/ComponentB";
import CarHistory from "./components/CarHistory"; // Import the new CarHistory component
import CarSpeed from "./components/CarSpeed";


import { fetchData } from "./functions/api";
import "./App.css";

function App() {
  const prevSource = useRef(null); // Remember the last selected source
  const [selectedGuardId, setSelectedGuardId] = useState(null);
  const [selectedGuard, setSelectedGuard] = useState(null);
  const [guardsData, setGuardsData] = useState([]);
  const [carStatus, setCarStatus] = useState({}); // Shared state for carStatus
  const [refresh, setRefresh] = useState(6000);
  const location = useLocation();
  const [selectedSource, setSelectedSource] = useState("master.php");

  useEffect(() => {
    const fetchGuardsData = () => {
      // Clear data ONLY if the source actually changed
      if (prevSource.current !== selectedSource) {
        setGuardsData([]);
        prevSource.current = selectedSource;
      }

      fetchData(selectedSource)
        .then((data) => {
          if (Array.isArray(data)) {
            setGuardsData(data);
          } else {
            console.warn("Invalid guards data received:", data);
            setGuardsData([]);
          }
          console.log("Fetched data:", data);
        })
        .catch((error) => {
          console.error("Failed to fetch data:", error);
          setGuardsData([]);
        });
    };

    fetchGuardsData();

    const intervalId = setInterval(fetchGuardsData, refresh);
    return () => clearInterval(intervalId);
  }, [refresh, selectedSource]);

  // Initialize carStatus from localStorage
  useEffect(() => {
    const savedCarStatus = JSON.parse(localStorage.getItem("carStatus")) || {};
    setCarStatus(savedCarStatus); // Load carStatus from localStorage if it exists
  }, []);

  // Function to update car status and save it to local storage
  const updateCarStatus = (serial, newStatus) => {
    console.log("triggered");

    const updatedStatus = {
      ...carStatus, // Spread the current car status state
      [serial]: newStatus, // Update the status for the specific car
    };

    console.log("Updated status:", updatedStatus);

    setCarStatus(updatedStatus); // Update the carStatus state

    // Save the updated status to localStorage
    localStorage.setItem("carStatus", JSON.stringify(updatedStatus));
  };

  return (
    <div className="grid-container">
      <div className="topsection">
        <div className="navig">
          <nav
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              padding: "1vh 1vw",
              boxSizing: "border-box",
              gap: "3px",
            }}>
            {location.pathname !== "/" && (
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  padding: "5px",
                  backgroundColor: "#627c99",
                  color: "white",
                  borderRadius: "999px",
                  fontSize: "20px",
                  fontWeight: "600",
                  border: "none",
                  cursor: "pointer",
                  transition: "background-color 0.3s, transform 0.2s",
                  textAlign: "center",
                  display: "inline-block",
                  minWidth: "140px",
                  margin: "auto",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#0056b3";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#007bff";
                  e.target.style.transform = "scale(1)";
                }}>
                Home
              </Link>
            )}

            {location.pathname === "/" && (
              <Link
                to="/carHistory"
                style={{
                  textDecoration: "none",
                  padding: "5px",
                  backgroundColor: "#363338",
                  color: "white",
                  borderRadius: "999px",
                  fontSize: "20px",
                  fontWeight: "600",
                  border: "none",
                  cursor: "pointer",
                  transition: "background-color 0.3s, transform 0.2s",
                  textAlign: "center",
                  display: "inline-block",
                  minWidth: "140px",
                  margin: "auto",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#746f78";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#363338";
                  e.target.style.transform = "scale(1)";
                }}>
                Car History
              </Link>
            )}

            {location.pathname === "/" && (
              <Link
                to="/carSpeed"
                style={{
                  textDecoration: "none",
                  padding: "5px",
                  backgroundColor: "#363338",
                  color: "white",
                  borderRadius: "999px",
                  fontSize: "20px",
                  fontWeight: "600",
                  border: "none",
                  cursor: "pointer",
                  transition: "background-color 0.3s, transform 0.2s",
                  textAlign: "center",
                  display: "inline-block",
                  minWidth: "140px",
                  margin: "auto",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#746f78";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#363338";
                  e.target.style.transform = "scale(1)";
                }}>
                Car Speed
              </Link>
            )}
          </nav>
        </div>
        <div className="titlecomp">
          <TitleComponent />
        </div>
      </div>
      {location.pathname === "/" && (
        <>
          <button
            className="no-print"
            onClick={() => window.print()}
            style={{
              position: "fixed",
              bottom: "7vh",
              left: "12vw",
              padding: "1vh 2vw",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "1rem",
              zIndex: 9999,
            }}>
            Print Map
          </button>

          <div className="no-print" style={{ position: "fixed", bottom: "7vh", left: "27vw", zIndex: 9999 }}>
            <label htmlFor="sourceSelect" style={{ color: "white", marginRight: "8px" }}>
              Data Source:
            </label>
            <select
              id="sourceSelect"
              value={selectedSource}
              onChange={(e) => setSelectedSource(e.target.value)}
              style={{
                padding: "1vh 2vw",
                borderRadius: "8px",
                fontSize: "1rem",
              }}>
              <option value="master.php">All</option>
              <option value="master_cars.php">Cars</option>
              <option value="master_officials.php">Officials</option>
              <option value="master_checkpoints.php">Checkpoints</option>
            </select>
          </div>
        </>
      )}

      <Routes>
        <Route
          path="/"
          element={
            <div className="bottomsection">
              <div className="mapItem">
                <MapComponent guardsData={guardsData} selectedGuardId={selectedGuardId} setSelectedGuardId={setSelectedGuardId} selectedGuardB={selectedGuard} carStatus={carStatus} />
              </div>
              <div className="itemB">
                <ComponentB guardsData={guardsData} onSelectGuard={(idx) => setSelectedGuardId(idx)} setSelectedGuard={setSelectedGuard} carStatus={carStatus} updateCarStatus={updateCarStatus} setRefresh={setRefresh} />
              </div>
            </div>
          }
        />
        <Route path="/carHistory" element={<CarHistory setRefresh={setRefresh} />} />
        <Route path="/carSpeed" element={<CarSpeed setRefresh={setRefresh} />} />
      </Routes>
    </div>
  );
}

export default App;
